const MembershipValidityPeriodType = Object.freeze({
    MONTH: 'Month',
    YEAR: 'Year',
});

module.exports = MembershipValidityPeriodType;
